"use client";

import { Component, type ReactNode } from "react";

/**
 * Drops the 3D scene if it fails, for instance where WebGL is unavailable,
 * leaving the HTML version it would have replaced.
 */
export class SceneBoundary extends Component<{ children: ReactNode; onError?: () => void }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    console.warn("Bookshelf scene unavailable:", error);
    this.props.onError?.();
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
